<template>
  <div class="products-description-area ptb-100">
    <div class="container mw-1356">
      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <ul class="nav nav-tabs description-tabs">
            <li class="nav-item">
              <button
                class="nav-link"
                type="button"
                :class="['tab', { active: activeTab === 'description' }]"
                @click="setActiveTab('description')"
              >
                الوصف
              </button>
            </li>
            <li class="nav-item">
              <button
                class="nav-link"
                type="button"
                :class="['tab', { active: activeTab === 'reviews' }]"
                @click="setActiveTab('reviews')"
              >
                المراجعات
              </button>
            </li>
          </ul>

          <div class="tab-content">
            <div v-show="activeTab === 'description'">
              <div class="products-description">
                <p>
                  الاستقرار والسرعة هما عصب تجربة المشاهدة الرقمية. يجب أن يوفر اشتراك IPTV الممتاز تدفقاً فائق السرعة وبثاً ثابتاً يلبي متطلبات القنوات الحية المشفرة والأحداث الرياضية الكبرى بدقة عالية بدون تقطيع. ابحث عن الباقات التي تتوافق مع نمط مشاهدتك، سواء كنت مستخدماً عادياً أو متعطشاً لمتابعة المباريات والأفلام بجودة 4K على أجهزة متعددة.
                </p>
                <p>
                  في عصر أصبحت فيه تفاصيل حياتنا اليومية منسوجة بالكامل في النسيج الرقمي، لا يمكن التغاضي عن أهمية اختيار مزود خدمة IPTV موثوق وعالي الأداء لضمان ترفيه منزلي متكامل ومستقر.
                </p>
                <ul class="ps-0 mb-0 list-unstyled description-liist">
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span
                      >تطبيق إجراءات متقدمة لحماية وتأمين بيانات اشتراكك.</span
                    >
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span
                      >اتصال بث سلس ومستقر تماماً دون أي انقطاع أثناء المباريات الكبرى.</span
                    >
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ti ti-circle-check"></i>
                    <span>اتصال فوري وسريع بالسيرفرات أفضل من أي وقت مضى.</span>
                  </li>
                </ul>

                <div class="pb-100"></div>

                <div class="comments-wrap">
                  <h3>03 تعليقات</h3>

                  <div class="d-flex comment-list mb-4">
                    <div class="flex-shrink-0">
                      <img src="@/assets/images/comment.jpg" alt="comment" />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h4>أنجيلا كارتر</h4>
                      <span>11 يناير، 2026، 08:14 م</span>
                      <p>
                        السيرفر ممتاز جداً والتجربة تخطت توقعاتي! تم تشغيله على الشاشة الذكية بسهولة والدعم الفني كان متعاوناً للغاية في شرح تفعيل الباقة ومتابعة الاستقرار.
                      </p>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1 start">
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d-flex comment-list ms-80">
                    <div class="flex-shrink-0">
                      <img src="@/assets/images/comment-2.jpg" alt="comment" />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h4>جين رونان</h4>
                      <span>11 يناير، 2026، 08:14 م</span>
                      <p>
                        جودة الـ 4K حقيقية والافلام المترجمة يتم تحديثها يومياً. جربت قنوات بي إن سبورت أثناء مباريات الويكند وكان الثبات رهيباً بدون أي لاق.
                      </p>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1 start">
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                        <li>
                          <i class="ti ti-star-filled"></i>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="pb-100"></div>

                <form class="comment-form">
                  <div
                    class="d-flex align-items-center justify-content-between mb-35 flex-wrap gap-2"
                  >
                    <h3 class="mb-0">اضف مراجعة</h3>
                    <div class="d-flex align-items-center review">
                      <span>أضف تقييمك:</span>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1">
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-floating mb-4">
                        <textarea
                          class="form-control"
                          id="floatingInput4"
                          placeholder="اكتب مراجعتك هنا"
                          cols="30"
                          rows="5"
                        ></textarea>
                        <label for="floatingInput4">اكتب مراجعتك هنا</label>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-floating mb-4">
                        <input
                          type="text"
                          class="form-control"
                          id="floatingInput1"
                          placeholder="الاسم"
                        />
                        <label for="floatingInput1">الاسم</label>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-floating mb-4">
                        <input
                          type="email"
                          class="form-control"
                          id="floatingInput2"
                          placeholder="البريد الإلكتروني"
                        />
                        <label for="floatingInput2">البريد الإلكتروني</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-floating mb-4">
                        <input
                          type="url"
                          class="form-control"
                          id="floatingInput3"
                          placeholder="الموقع الإلكتروني"
                        />
                        <label for="floatingInput3">الموقع الإلكتروني</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-check mb-4">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault"
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          احفظ اسمي، بريدي الإلكتروني، وموقعي الإلكتروني في هذا المتصفح للتعليق في المرة القادمة.
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <button type="submit" class="btn">
                        <span class="border-style">انشر المراجعة الآن</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
			<div v-show="activeTab === 'reviews'">
              <div class="products-description">
                <div class="comments-wrap">
                  <h3>03 تعليقات</h3>

                  <div class="d-flex comment-list mb-4">
                    <div class="flex-shrink-0">
                      <img src="@/assets/images/comment.jpg" alt="comment" />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h4>أنجيلا كارتر</h4>
                      <span>11 يناير، 2026، 08:14 م</span>
                      <p>
                        السيرفر ممتاز جداً والتجربة تخطت توقعاتي! تم تشغيله على الشاشة الذكية بسهولة والدعم الفني كان متعاوناً للغاية في شرح تفعيل الباقة ومتابعة الاستقرار.
                      </p>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1 start">
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                      </ul>
                    </div>
                  </div>

                  <div class="d-flex comment-list ms-80">
                    <div class="flex-shrink-0">
                      <img src="@/assets/images/comment-2.jpg" alt="comment" />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h4>جين رونان</h4>
                      <span>11 يناير، 2026، 08:14 م</span>
                      <p>
                        جودة الـ 4K حقيقية والافلام المترجمة يتم تحديثها يومياً. جربت قنوات بي إن سبورت أثناء مباريات الويكند وكان الثبات رهيباً بدون أي لاق.
                      </p>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1 start">
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star-filled"></i></li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="pb-100"></div>

                <form class="comment-form">
                  <div
                    class="d-flex align-items-center justify-content-between mb-35 flex-wrap gap-2"
                  >
                    <h3 class="mb-0">اضف مراجعة</h3>
                    <div class="d-flex align-items-center review">
                      <span>أضف تقييمك:</span>
                      <ul class="ps-0 mb-0 list-unstyled d-flex gap-1">
                        <li><i class="ti ti-star-filled"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                        <li><i class="ti ti-star"></i></li>
                      </ul>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-floating mb-4">
                        <textarea
                          class="form-control"
                          id="floatingInput44"
                          placeholder="اكتب مراجعتك هنا"
                          cols="30"
                          rows="5"
                        ></textarea>
                        <label for="floatingInput44">اكتب مراجعتك هنا</label>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-floating mb-4">
                        <input
                          type="text"
                          class="form-control"
                          id="floatingInput11"
                          placeholder="الاسم"
                        />
                        <label for="floatingInput11">الاسم</label>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-floating mb-4">
                        <input
                          type="email"
                          class="form-control"
                          id="floatingInput22"
                          placeholder="البريد الإلكتروني"
                        />
                        <label for="floatingInput22">البريد الإلكتروني</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-floating mb-4">
                        <input
                          type="url"
                          class="form-control"
                          id="floatingInput33"
                          placeholder="الموقع الإلكتروني"
                        />
                        <label for="floatingInput33">الموقع الإلكتروني</label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-check mb-4">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckDefault1"
                        />
                        <label class="form-check-label" for="flexCheckDefault1">
                          احفظ اسمي، بريدي الإلكتروني، وموقعي الإلكتروني في هذا المتصفح للتعليق في المرة القادمة.
                        </label>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <button type="submit" class="btn">
                        <span class="border-style">انشر المراجعة الآن</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useRoute } from "vue-router";
import { useHead } from "@unhead/vue";
import SidebarWidget from "../Products/SidebarWidget.vue";

export default defineComponent({
  name: "ProductDetails",
  components: {
    SidebarWidget,
  },
  setup() {
    const route = useRoute();
    const activeTab = ref("description");

    const productsSeo = [
      {
        id: 1,
        image: require("@/assets/images/product-1.jpg"),
        price: 60.0,
        oldPrice: 90.0,
        name: "اشتراك IPTV الماسي - 12 شهر (شاشتين في نفس الوقت)",
        seoTitle: "اشتراك IPTV الماسي 12 شهر | شاشتين بجودة HD و4K",
        seoDescription:
          "اشتراك IPTV الماسي لمدة 12 شهر يدعم شاشتين في نفس الوقت مع قنوات عربية وعالمية وأفلام ومسلسلات بجودة HD و4K.",
        keywords:
          "اشتراك IPTV 12 شهر, IPTV شاشتين, IPTV الماسي, قنوات عربية, IPTV 4K",
      },
      {
        id: 2,
        image: require("@/assets/images/product-2.jpg"),
        price: 35.0,
        name: "اشتراك IPTV الماسي - 6 أشهر (ثبات مطلق للمباريات)",
        seoTitle: "اشتراك IPTV 6 أشهر | بث ثابت للمباريات والقنوات الرياضية",
        seoDescription:
          "اشتراك IPTV لمدة 6 أشهر مناسب لمتابعة المباريات والقنوات الرياضية بثبات عالي وجودة HD و4K.",
        keywords:
          "اشتراك IPTV 6 أشهر, IPTV مباريات, قنوات رياضية, بث مباشر, IPTV HD",
      },
      {
        id: 3,
        image: require("@/assets/images/product-3.jpg"),
        price: 25.0,
        name: "اشتراك IPTV الماسي - 3 أشهر (جميع القنوات والـ VOD)",
        seoTitle: "اشتراك IPTV 3 أشهر | قنوات وVOD بجودة عالية",
        seoDescription:
          "اشتراك IPTV لمدة 3 أشهر يشمل القنوات العربية والعالمية ومكتبة VOD للأفلام والمسلسلات بجودة عالية.",
        keywords:
          "اشتراك IPTV 3 أشهر, IPTV VOD, أفلام IPTV, مسلسلات IPTV, قنوات عربية",
      },
      {
        id: 4,
        image: require("@/assets/images/product-4.jpg"),
        price: 95.0,
        name: "جهاز Fire TV Stick 4K مجهز ومبرمج باشتراك سنة كاملة",
        seoTitle: "Fire TV Stick 4K مع اشتراك IPTV سنة كاملة",
        seoDescription:
          "جهاز Fire TV Stick 4K مجهز ومبرمج مع اشتراك IPTV لمدة سنة كاملة لتشغيل القنوات والأفلام والمسلسلات بسهولة.",
        keywords:
          "Fire TV Stick IPTV, جهاز IPTV, IPTV 4K, اشتراك IPTV سنة, فاير ستيك",
      },
      {
        id: 5,
        image: require("@/assets/images/product-5.jpg"),
        price: 85.0,
        name: "باقة العائلة المتكاملة - اشتراك IPTV لمدة 12 شهر (3 أجهزة)",
        seoTitle: "باقة IPTV العائلية 12 شهر | تشغيل على 3 أجهزة",
        seoDescription:
          "باقة IPTV عائلية لمدة سنة كاملة تدعم 3 أجهزة، مناسبة للمنزل والعائلة مع قنوات وأفلام ومسلسلات بجودة عالية.",
        keywords:
          "باقة IPTV عائلية, IPTV 3 أجهزة, اشتراك IPTV عائلي, IPTV سنة",
      },
      {
        id: 6,
        image: require("@/assets/images/product-6.jpg"),
        price: 70.0,
        name: "اشتراك IPTV VIP - لمدة 12 شهر بجودة 4K حقيقية",
        seoTitle: "اشتراك IPTV VIP سنة كاملة | جودة 4K حقيقية",
        seoDescription:
          "اشتراك IPTV VIP لمدة 12 شهر بجودة 4K حقيقية، مناسب لمحبي الجودة العالية والقنوات المميزة.",
        keywords:
          "IPTV VIP, اشتراك IPTV 4K, IPTV سنة, قنوات 4K, اشتراك مميز",
      },
      {
        id: 7,
        image: require("@/assets/images/product-7.jpg"),
        price: 75.0,
        name: "جهاز Android TV Box مبرمج بالكامل مع اشتراك 6 أشهر",
        seoTitle: "Android TV Box مع اشتراك IPTV 6 أشهر",
        seoDescription:
          "جهاز Android TV Box مبرمج بالكامل مع اشتراك IPTV لمدة 6 أشهر لتشغيل القنوات والأفلام والمسلسلات بسهولة.",
        keywords:
          "Android TV Box IPTV, جهاز أندرويد IPTV, IPTV 6 أشهر, Android TV",
      },
      {
        id: 8,
        image: require("@/assets/images/product-8.jpg"),
        price: 10.0,
        oldPrice: 15.0,
        name: "باقة تجريبية خاصة - اشتراك IPTV لمدة شهر كامل",
        seoTitle: "اشتراك IPTV شهر واحد | باقة تجريبية خاصة",
        seoDescription:
          "جرّب اشتراك IPTV لمدة شهر كامل لمشاهدة القنوات العربية والعالمية والأفلام والمسلسلات قبل اختيار الباقة الطويلة.",
        keywords:
          "اشتراك IPTV شهر, تجربة IPTV, باقة IPTV تجريبية, IPTV قصير",
      },
      {
        id: 9,
        image: require("@/assets/images/product-9.jpg"),
        price: 110.0,
        name: "الاشتراك الملكي المستقر - سنتين كاملتين (24 شهر)",
        seoTitle: "اشتراك IPTV سنتين | باقة 24 شهر بثابت عالي",
        seoDescription:
          "اشتراك IPTV لمدة سنتين كاملتين 24 شهر مع قنوات عربية وعالمية وأفلام ومسلسلات بجودة عالية وثبات ممتاز.",
        keywords:
          "اشتراك IPTV سنتين, IPTV 24 شهر, اشتراك طويل IPTV, IPTV مستقر",
      },
    ];

    const productSeo = computed(() => {
      return productsSeo.find(
        (product) => product.id === Number(route.params.id)
      );
    });

    useHead(() => {
      const currentProduct = productSeo.value;
      const productUrl = currentProduct
        ? `https://karamtv4k.com/product-details/${currentProduct.id}`
        : "https://karamtv4k.com/products";

      const productImage = currentProduct?.image
        ? new URL(currentProduct.image, "https://karamtv4k.com").href
        : "https://karamtv4k.com/img/product-1.jpg";

      return {
        title: currentProduct?.seoTitle || "تفاصيل المنتج | Karam TV 4K",
        meta: [
          {
            name: "description",
            content:
              currentProduct?.seoDescription ||
              "تعرف على تفاصيل اشتراكات IPTV والباقات المتاحة بجودة HD و4K.",
          },
          {
            name: "keywords",
            content:
              currentProduct?.keywords ||
              "IPTV, اشتراك IPTV, قنوات عربية, IPTV 4K",
          },
          {
            property: "og:title",
            content: currentProduct?.seoTitle || "تفاصيل المنتج | Karam TV 4K",
          },
          {
            property: "og:description",
            content:
              currentProduct?.seoDescription ||
              "تعرف على تفاصيل اشتراكات IPTV والباقات المتاحة.",
          },
          {
            property: "og:type",
            content: "product",
          },
          {
            property: "og:url",
            content: productUrl,
          },
          {
            property: "og:image",
            content: productImage,
          },
          {
            property: "og:image:secure_url",
            content: productImage,
          },
          {
            property: "og:image:type",
            content: "image/jpeg",
          },
          {
            property: "og:image:width",
            content: "1200",
          },
          {
            property: "og:image:height",
            content: "630",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
          {
            name: "twitter:title",
            content: currentProduct?.seoTitle || "تفاصيل المنتج | Karam TV 4K",
          },
          {
            name: "twitter:description",
            content:
              currentProduct?.seoDescription ||
              "تعرف على تفاصيل اشتراكات IPTV والباقات المتاحة.",
          },
          {
            name: "twitter:image",
            content: productImage,
          },
          {
            name: "robots",
            content: currentProduct ? "index, follow" : "noindex, follow",
          },
        ],
        link: [
          {
            rel: "canonical",
            href: productUrl,
          },
        ],
        script: currentProduct
          ? [
              {
                type: "application/ld+json",
                innerHTML: JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "Product",
                  name: currentProduct.name,
                  image: productImage,
                  description: currentProduct.seoDescription,
                  brand: {
                    "@type": "Brand",
                    name: "Karam TV 4K",
                  },
                  offers: {
                    "@type": "Offer",
                    url: productUrl,
                    priceCurrency: "EUR",
                    price: currentProduct.price,
                    availability: "https://schema.org/InStock",
                    itemCondition: "https://schema.org/NewCondition",
                  },
                }),
              },
            ]
          : [],
      };
    });

    const setActiveTab = (tab: string) => {
      activeTab.value = tab;
    };

    return {
      activeTab,
      setActiveTab,
    };
  },
});
</script>